/**
 * Zzzing Land Owner API
 * Zzzing Land Owner API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Reservation State
 */
export type ReservationState = 'CONFIRMED' | 'MODIFIED' | 'IN_ERROR' | 'WITHDRAWN' | 'CANCELLED' | 'CHECKED_OUT';

export const ReservationState = {
    CONFIRMED: 'CONFIRMED' as ReservationState,
    MODIFIED: 'MODIFIED' as ReservationState,
    INERROR: 'IN_ERROR' as ReservationState,
    WITHDRAWN: 'WITHDRAWN' as ReservationState,
    CANCELLED: 'CANCELLED' as ReservationState,
    CHECKEDOUT: 'CHECKED_OUT' as ReservationState
};

